<template>
  <div class="date-duration-input clearfix">
    <div class="form-group" :class="{ 'has-feedback' : isDirty }">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 control-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <input type='text' class="form-control"
          :id="options.name"
          :name="options.name"
          :value="value"
          @input="validate($event.target.value)"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DateDurationInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          required: false
        }
      }
    }
  },
  data () {
    return {
      invalidMessage: 'The duration you entered is not valid',
      datePicker: {},
      regex: /(\d)+\.*(\d)*\s*(day)*(hour)*/gi
    }
  },
  mounted () {
    if (this.value) {
      let str = ''
      let days = Math.floor(this.value / 24)
      if (days > 0) {
        str = `${days} day${days > 0 ? 's' : ''}`
      }
      let hours = this.value - (days * 24.00)
      if (hours > 0) {
        if (days > 0) {
          str += ` and ${hours} hour${hours > 0 ? 's' : ''}`
        } else {
          str += `${hours} hour${hours > 0 ? 's' : ''}`
        }
      }
      this.$emit('input', str)
    }
  },
  methods: {
    validate (val = this.value) {
      if (this.options.required && val === '') {
        this.isValid = false
      }
      if (!this.options.required && val === '') {
        this.isValid = true
        this.isDirty = false
      }
      if (val !== '') {
        this.isDirty = true
        let matches = []
        let totalHours = 0.0
        while (
          (matches = this.regex.exec(val)) !== null &&
          this.regex.lastIndex !== 0
        ) {
          let hours = 0.0
          if (matches[3]) {
            // day detected
            hours += matches[1] * 24.00
            if (matches[2]) {
              hours += (matches[2] / 10.00) * 24.00
            }
          }
          if (matches[4]) {
            // hours detected
            hours += matches[1] * 1.00
            if (matches[2]) {
              hours += (matches[2] / 10.00)
            }
          }
          totalHours += hours
        }
        this.isValid = totalHours > 0
      }
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/DateDurationInput.vue